import $ from 'jquery/dist/jquery.slim'

export default function() {

    const wWidth = $(window).width();


    $(window).on('scroll', () => {

        const wScroll      = $(window).scrollTop();
        const headerHeight = $('#header').innerHeight();

        let blur = $('.scrollBlur');


        if( wScroll <= headerHeight ) {

            //let blur = Math.round(wScroll * .05);
            let opacity = wScroll / (wWidth / 7);

            //console.log(wWidth, opacity);

            //blur.css({'filter': 'blur(' + blur + 'px)'});
            blur.css({'opacity': opacity});
        }



    })

}



// WEBPACK FOOTER //
// ./src/js/scrollBlur.js